<template>
  <div>
    <v-container class="sponsorship-container" fluid>
      <div v-for="(counters, department) in groupedCounters" :key="department" class="department-card">

        <!-- Department Header -->
        <div class="department-header">
          <h2>{{ department.toUpperCase() }}</h2>
        </div>

        <div class="counters-container">
          <div v-for="counter in counters" :key="counter.id" class="counter-section mt-2">

            <v-row class="counter-title" align="center" justify="space-between">
              <!-- Left Side: Student Count -->
              <v-col cols="3" class="text-left">
                <h3>{{ counter.needed }} {{ counter.name.toUpperCase() }}</h3>
              </v-col>

              <!-- Middle: Needed, Received, Balance -->
              <v-col cols="6" class="text-center">
                <v-row justify="center">
                  <v-col cols="4">
                    <div class="details-label">Needed</div>
                    <div class="details-value">{{ counter.needed }}</div>
                  </v-col>
                  <v-col cols="4">
                    <div class="details-label">Received</div>
                    <div class="details-value">{{ counter.received }}</div>
                  </v-col>
                  <v-col cols="4">
                    <div class="balance-label">Balance</div>
                    <div :class="['balance-value', balanceAnimations[counter.id]]"
                      @animationend="removeAnimation(counter.id)">
                      {{ balance(counter) }}
                    </div>
                  </v-col>

                </v-row>
              </v-col>

              <!-- Right Side: Pricing Info -->
              <v-col cols="3" class="text-right">
                <div class="price-month">${{ counter.metadata.pricePerMonth }}/MONTH</div>
                <div class="price-year">${{ counter.metadata.pricePerYear }} For a Year</div>
              </v-col>
            </v-row>


            <div class="student-grid">
              <span v-for="(n, index) in counter.needed || 0" :key="index" :class="{
                'sponsored': index < counter.received,
                'shake-icon': index === counter.received - 1 // ✅ Only shake the most recently updated icon
              }">
                <svg-icon type="mdi" :path="index < counter.received ? mdiAccountSchool : mdiAccountOutline" />
              </span>
            </div>

          </div>
        </div>
      </div>
    </v-container>

    <!-- <div class="qrcode-container">
      <img :src="qrCodeUrl" alt="Scan to Donate" />
    </div> -->
    <div class="version-container">
      {{ packageVersion }}
    </div>
  </div>
</template>

<script>
import applicationService from "@/modules/Application/service.js";
import counterService from "../service.js";
import SvgIcon from '@jamescoyle/vue-icon';
import { mdiAccountSchool, mdiAccountOutline } from '@mdi/js';
import pjson from "../../../../package.json";

export default {
  name: 'counter-viewer',
  data() {
    return {
      Business: null,
      Counters: null,
      mdiAccountSchool: mdiAccountSchool,
      mdiAccountOutline: mdiAccountOutline,
      userKey: this.$route.params.id,
      balanceAnimations: {},
      qrValue: "https://portal.taleem.app/student-sponsor/muhammadimasjid",
      packageVersion: `V-${pjson.version}`, // Get version like v-1.5.5
    }
  },
  created() {
    if (!this.$route.params.id)
      this.$router.push({ name: "pagenotfound" });
    this.loadBusiness()
    this.loadCounter()
    this.joinRoom(); // Automatically join room when the component loads
  },
  // beforeDestroy() {
  //   if (this.socket) {
  //     this.socket.disconnect(); // Disconnect socket when component is destroyed
  //   }
  // },
  sockets: {
    connect() {
      console.log("✅ Socket connected");

      // ✅ Join room after connection
      this.$socket.emit("join", this.userKey);
    },
    counterUpdated(updatedCounter) {
      // console.log("🔥 Received real-time update:", updatedCounter);

      // Find the affected counter and update it
      this.Counters = this.Counters.map(counter => {
        if (counter.id === updatedCounter.id) {
          // Trigger animation for only this counter
          this.$set(this.balanceAnimations, counter.id, "scale"); // Apply animation

          // Remove animation after a short delay
          setTimeout(() => {
            this.$delete(this.balanceAnimations, counter.id); // Remove animation
          }, 700);

          return updatedCounter;
        }
        return counter;
      });
    },
  },
  components: {
    SvgIcon
  },
  computed: {
    qrCodeUrl() {
      return `https://api.qrserver.com/v1/create-qr-code/?size=150x150&data=${encodeURIComponent(
        this.qrValue
      )}`;
    },
    groupedCounters() {
      if (!Array.isArray(this.Counters) || this.Counters.length === 0) {
        return {}; // Prevent errors if data is empty
      }

      return this.Counters.reduce((acc, counter) => {
        if (!acc[counter.dep]) {
          acc[counter.dep] = [];
        }
        acc[counter.dep].push({
          ...counter,
          metadata: {
            needed: Number(counter.needed) || 0,
            received: Number(counter.received) || 0,
            pricePerMonth: counter.dep === 'Maktab Program' ? 50 : counter.dep === 'Hifz Program' ? 100 : 150,
            pricePerYear: counter.dep === 'Maktab Program' ? 600 : counter.dep === 'Hifz Program' ? 1200 : 1800
          }
        });
        return acc;
      }, {});
    }
  },
  methods: {
    removeAnimation(counterId) {
      this.$delete(this.balanceAnimations, counterId); // Remove animation
    },
    joinRoom() {
      if (this.$socket) {
        console.log("🔥 Emitting join event with room name:", this.userKey);
        this.$socket.emit("join", this.userKey);
      } else {
        console.error("❌ Socket not initialized");
      }
    },
    // updateCounterService(counterId, newReceived) {
    //   // Send update request to backend
    //   this.socket.emit("updateCounterService", { id: counterId, received: newReceived });
    // },
    balance(counter) {
      let needed = counter.needed ? parseInt(counter.needed) : 0;
      let received = counter.received ? parseInt(counter.received) : 0;
      return needed - received;
    },
    // balance(row) {
    //   let balance = row.metadata.needed ? parseInt(row.metadata.needed) : 0
    //   balance -= row.metadata.received ? parseInt(row.metadata.received) : 0
    //   return balance
    // },
    loadBusiness() {
      let id = this.$route.params.id;
      applicationService
        .getBusinessInformation({ key: id })
        .then((response) => {
          this.Business = response.data;
        })
        .catch((error) => {
          console.log("error getting business", error);
          this.$router.push({ name: "pagenotfound" });
        });
    },
    groupByDepartment(dataArray) {
      return dataArray.reduce((acc, item) => {
        if (!acc[item.dep]) {
          acc[item.dep] = [];
        }
        acc[item.dep].push(item);
        return acc;
      }, {});
    },
    loadCounter() {
      let id = this.$route.params.id;
      counterService
        .getPublicCounterList({ key: id })
        .then((response) => {
          console.log("response", response);
          this.Counters = response.data
          // this.Counters = this.groupByDepartment(response.data)
          console.log("Counters", this.Counters);
        })
        .catch((error) => {
          console.log("error getting Counters", error);
        });
    },
  }

}
</script>

<style scoped>
/* Ensure the container fills the screen */
.sponsorship-container {
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  align-items: center;
  text-align: center;
  font-family: Arial, sans-serif;
  background-color: #eaf4e2;
  padding: 1vh;
  height: 100vh;
  /* Full screen height */
  width: 100vw;
  /* Full screen width */
  overflow: hidden;
  /* Prevent scrolling */
}

/* Each department section */
.department-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-evenly;
  border: 3px solid #2c5b27;
  background: white;
  padding: 1vh;
  margin: 0.5vh 0;
  border-radius: 10px;
  width: 95vw;
  /* Responsive width */
}

/* Automatically adjust height based on content */
.counter-section {
  display: flex;
  flex-direction: column;
  align-items: center;
  border: 2px solid #ccc;
  border-radius: 8px;
  padding: 1vh;
  background: #f8f8f8;
  width: 48%;
  height: auto;
  /* Set dynamic height */
  min-height: 10vh;
  /* Minimum height for small groups */
  max-height: 30vh;
  /* Prevent it from being too big */
}

/* Header section */
.department-header {
  background: #2c5b27;
  color: white;
  padding: 1vh;
  font-size: 2vh;
  /* Scale with screen size */
  font-weight: bold;
  width: 100%;
  text-align: center;
}

/* Container for program sections */
.counters-container {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: flex-start;
  /* Align to top to prevent shifting */
  width: 100%;
  gap: 1vw;
  flex-wrap: wrap;
}

/* Ensure counter title is well aligned */
/* Ensure counter title is well aligned */
.counter-title {
  font-size: 2vh;
  font-weight: bold;
  width: 100%;
  margin-bottom: 0.5vh;
}

/* New Row for Needed, Received, and Balance */
.counter-details {
  font-size: 1.8vh;
  font-weight: bold;
  width: 100%;
  margin-top: 0.5vh;
}

/* Label styling for needed and received */
.details-label {
  font-size: 1.5vh;
  color: #666;
}

/* Value styling for needed and received */
.details-value {
  font-size: 2vh;
  font-weight: bold;
}

/* Balance Styling (Make It Bigger) */
.balance-label {
  font-size: 1.6vh;
  color: #2c5b27;
  font-weight: bold;
}

.balance-value {
  font-size: 2.5vh;
  /* Bigger balance value */
  font-weight: bold;
  color: #d32f2f;
  /* Highlight balance in red */
}

/* Monthly price (top right) */
.price-month {
  font-size: 1.8vh;
  font-weight: bold;
  color: #2c5b27;
}

/* Yearly price (below monthly price) */
.price-year {
  font-size: 1.5vh;
  color: #555;
}

/* Sponsor details */
.sponsor-info {
  font-size: 1.5vh;
  font-weight: bold;
  color: #555;
  margin-bottom: 0.5vh;
}

/* Student grid auto adjusts */
.student-grid {
  display: grid;
  color: red;
  grid-template-columns: repeat(auto-fit, minmax(2vh, 1fr));
  /* Fit more students */
  justify-content: center;
  gap: 0.5vh;
  width: 90%;
  height: auto;
  overflow: auto;
}

/* Student icons auto scale */
.student-grid span {
  font-size: 2vh;
  /* Adjust size dynamically */
  transition: 0.3s;
}

/* Sponsored students are green */
.sponsored {
  color: green;
}

/* Ensure layout adjusts on smaller screens */
@media screen and (max-width: 1024px) {
  .counter-section {
    width: 100%;
    height: auto;
  }

  .student-grid {
    grid-template-columns: repeat(auto-fit, minmax(2vw, 1fr));
    /* Adjust layout */
  }

  .student-grid span {
    font-size: 2vw;
  }
}

/* Balance number shake animation */
@keyframes shake {

  0%,
  100% {
    transform: translateX(0);
  }

  25% {
    transform: translateX(-5px);
  }

  50% {
    transform: translateX(5px);
  }

  75% {
    transform: translateX(-5px);
  }
}

/* Increase and decrease size smoothly */
@keyframes scaleUp {
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(1.5);
    color: green;
  }

  /* Temporary highlight */
  100% {
    transform: scale(1);
  }
}

/* Student icon shake animation */
@keyframes shakeIcon {

  0%,
  100% {
    transform: rotate(0deg);
  }

  25% {
    transform: rotate(-5deg);
  }

  50% {
    transform: rotate(5deg);
  }

  75% {
    transform: rotate(-5deg);
  }
}

/* Apply animations when the balance updates */
.balance-value.shake {
  animation: shake 0.5s ease-in-out;
}

.balance-value.scale {
  animation: scaleUp 0.7s ease-in-out;
}

/* Apply shake effect on the first icon when balance updates */
.student-grid .shake-icon {
  animation: shakeIcon 0.7s ease-in-out;
}

.qrcode-container {
  position: fixed;
  top: 20px;
  /* Adjusted for top placement */
  right: 20px;
  /* Keep it aligned to the right */
  z-index: 999;
  background: white;
  padding: 10px;
  border-radius: 10px;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
}

.qrcode-container img {
  width: 100px;
  height: 100px;
}

.version-container {
  position: fixed;
  bottom: 10px;
  right: 20px;
  font-size: 14px;
  font-weight: bold;
  color: white;
  background: black;
  padding: 5px 10px;
  border-radius: 5px;
  opacity: 0.8;
  z-index: 999;
}
</style>
